import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createSubscriptionTypeFailed, createSubscriptionTypeSuccessful } from '../actions';
import { CREATED } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* createSubscriptionType(action) {
  try {
    const body = action.payload;
    const url = `${BACKEND_URL}/proxy/subscription/v1/presets`;
    const dataResponse = yield makeRequest(url, { ...body }, action, 'POST', true);
    if (dataResponse.status === CREATED) {
      yield put(createSubscriptionTypeSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(createSubscriptionTypeFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createSubscriptionTypeFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
